export { NotFoundPage } from './not-found';
